// FILECONTENT_START src/common/components/Toolbar/index.ts
import Toolbar from "./Toolbar";
export default Toolbar;
export type { ToolbarProps } from "./Toolbar";

// FILECONTENT_END src/common/components/Toolbar/index.ts